import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.string.replace-all.js";
import moment from 'moment';
import { planArea } from '../request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: ['infoBig', 'areaCode', 'index'],
  data() {
    return {
      value: '',
      currentRange: [],
      areaList: [],
      codes: [],
      info: [],
      replaceName: ['缴费期限', '保障期限']
    };
  },
  watch: {
    infoBig: {
      handler(newV) {
        this.info.controls = newV.controls;
        if (newV.controls == 1 || newV.controls == 6 || newV.controls == 4) {
          const obj = newV.controlsValue.find(item => this.info.controlsDefaultValue == item.name);
          this.info.controlsValue = recursionCopy(newV.controlsValue);
          // console.log(obj, 222);
          if (obj) {
            if (obj.disabled) {
              this.info.controlsDefaultType = obj.controlsDefaultType;
              this.info.controlsDefaultValue = obj.name;
            }
            // else {
            //   this.info.controlsDefaultValue = '';
            //   this.info.controlsDefaultType = '';
            // }
          } else {
            this.info.controlsDefaultValue = undefined;
            this.info.controlsDefaultType = undefined;
          }
          this.info.controlsValue.map((item, index) => {
            if (this.info.controlsDefaultValue && item.name != this.info.controlsDefaultValue) {
              this.info.controlsValue[index].disabled = false;
            }
          });
        } else if (newV.controls == 3 && newV.mark != 'areaPrice') {
          //逻辑不对,需要重新整理
          newV.controlsValue.map((item, index) => {
            item.index = index;
          });
          this.info.controlsValue = recursionCopy(newV.controlsValue);
          if (this.info.controlsDefaultValue.length) {
            console.log(this.info.controlsDefaultValue);
            // const obj = newV.controlsValue[this.info.controlsDefaultValue];
            // console.log(obj,2222);
            // if (obj.disabled) {
            //   this.info.controlsDefaultValue = [];
            // }
          }
        } else {
          this.info = recursionCopy(newV);
        }
        // if (newV.mark == 'duration') {
        //   this.info.controlsValue.map(item => {
        //     item.disabled=!item.disabled;
        //   });
        // }
      },
      deep: true
    },
    areaCode: {
      handler(newV) {
        if (newV && this.info.mark == 'areaPrice') {
          this.codes = newV;
          if (newV.length == 1 && newV[0] === '') {
            this.areaList = this.areaList.map(i => {
              i.disabled = true;
              return i;
            });
            return;
          }
          this.areaList = this.areaList.map(i => {
            if (!this.codes.includes(i.code + '')) {
              i.disabled = true;
            } else {
              i.disabled = false;
              if (i.child && i.child.length) {
                i.child = i.child.map(c => {
                  if (!this.codes.includes(c.code + '')) {
                    c.disabled = true;
                  } else {
                    c.disabled = false;
                    i.child[0].disabled = true;
                  }
                  return c;
                });
              } else {
                i.disabled = false;
              }
            }
            return i;
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.info = recursionCopy(this.infoBig);
    if (this.info.controls == 3 && this.info.mark != 'areaPrice') {
      this.info.controlsValue.map((item, index) => {
        item.disabled = !item.disabled;
        item.controlsDefaultValue = [];
      });
    } else if (this.info.controls == 5) {
      this.info.controlsValue.map((item, index) => {
        item.controlsDefaultValue = [];
      });
    }
    console.log(this.info.controlsValue, 2222);
    if (this.info.mark == 'areaPrice') {
      this.codes = this.areaCode;
      planArea({
        level: 2
      }).then(res => {
        if (this.codes.includes('')) {
          this.areaList = res;
          return;
        }
        this.areaList = res.map(i => {
          if (!this.codes.includes(i.code + '')) {
            i.disabled = true;
          } else {
            if (i.child && i.child.length) {
              i.child = i.child.map(c => {
                if (!this.codes.includes(c.code + '')) {
                  c.disabled = true;
                } else {
                  c.disabled = false;
                  i.child[0].disabled = true;
                }
                return c;
              });
            }
          }
          return i;
        });
      });
    }
    if (this.info.mark == 'age' && !this.info.controlsDefaultType) {
      this.info.controlsDefaultType = undefined;
    }
  },
  methods: {
    unitReplace(value) {
      if (value) {
        let _value = value.replaceAll('年', this.$t('年')).replaceAll('季', this.$t('季')).replaceAll('月', this.$t('月')).replaceAll('周', this.$t('周')).replaceAll('天', this.$t('天'));
        return this.$t(_value);
      }
    },
    changeAgeNumber(isDisabled) {
      this.info.controlsDefaultValue = this.info.controlsDefaultValue
      // .replace(/^\./g, '')
      // .replace(/^\-/g, '')
      .replace(/[^\d]/g, '');
      if (this.info.controlsDefaultValue.length && this.info.controlsDefaultValue.length > 5) {
        this.info.controlsDefaultValue = this.info.controlsDefaultValue.substr(0, 5);
        this.$message.warn(this.$t('最大输入5位数'));
        return;
      }
      this.informChange('age', isDisabled);
    },
    disabledDate(current) {
      let hasRange = this.currentRange.length > 1 ? true : false;
      let minType = this.currentRange[0].type;
      let minValue = Number(this.currentRange[0].value);
      let maxType = hasRange ? this.currentRange[1].type : undefined;
      let maxValue = hasRange ? Number(this.currentRange[1].value) : undefined;
      let min = this.getRange(minType, minValue, current);
      let max = hasRange ? this.getRange(maxType, maxValue, current) : undefined;
      if (hasRange) {
        return current < min || current > max;
      }
      return current > min;
    },
    getRange(type, value) {
      if (type == 1 || type == 7) {
        return moment().subtract(value, 'days');
      } else if (type == 2 || type == 8) {
        return moment().subtract(value, 'months');
      } else if (type == 3 || type == 6) {
        return moment().subtract(value, 'years');
      }
    },
    changeAge(a) {
      this.info.controlsDefaultValue = '';
      this.currentRange = this.info.controlsValue.find(i => i.type == a).value;
      // this.$set(this.info, 'controlsDefaultType', a);
    },
    informChange(key, isDisabled) {
      let obj = {
        controlsDefaultValue: this.info.controlsDefaultValue
      };
      if (key == 'age') {
        obj = {
          controlsDefaultValue: this.info.controlsDefaultValue,
          controlsDefaultType: this.info.controlsDefaultType
        };
      } else if (key == 'radio' || key == 'select') {
        //1  6
        const obj2 = this.infoBig.controlsValue.find(item => item.name == this.info.controlsDefaultValue);
        obj = {
          controlsDefaultValue: obj2.value || obj2.name,
          controlsDefaultType: obj2.type || ''
        };
      } else if (key == 'cascader' || key == 'checkbox') {
        //逻辑不对,需要重新整理
        obj = {
          controlsDefaultValue: [],
          controlsDefaultType: []
        };
        this.info.controlsDefaultValue.map((item, index) => {
          if (index == 0) {
            const obj2 = this.info.controlsValue.find(item2 => item2.name == item);
            obj.controlsDefaultValue.push(obj2.value);
            obj.controlsDefaultType.push(obj2.type);
          }
        });
        console.log(obj);
      }
      this.$emit('filter', obj, this.index, isDisabled);
    }
  }
};